var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog',{ref:"dialog",attrs:{"id":"axiosRes"}},[_c('div',{attrs:{"id":"axiosBox"}},[_c('h2',[_vm._v("系统提示")]),_vm._v(" "),_c('p',{attrs:{"id":"axiosContent","onclick":"axiosRes.showModal()"}}),_vm._v(" "),_c('Button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("我知道了")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c258ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/axiosRes.vue
// module id = null
// module chunks = 